module.exports = __webpack_public_path__ + "img/line4.5b08a1b1.png";